import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParametroService {
  // private configUrl = 'api/parametros';
  private configUrl = [environment.apiGatewayUrl, 'parametros'].join('/');
  constructor(private http: HttpClient) { }

  getList() : Observable<SearchResultModel<ParametroModel[]>> {
    return this.http.get<SearchResultModel<ParametroModel[]>>(`${this.configUrl}`);
  }

  get(id: number) : Observable<SearchResultModel<ParametroModel[]>> {
    return this.http.get<SearchResultModel<ParametroModel[]>>(`${this.configUrl}/${id}`);
  }

  getDetalles(id: number) : Observable<SearchResultModel<ParametroModel[]>> {
    return this.http.get<SearchResultModel<ParametroModel[]>>(`${this.configUrl}/${id}/items`);
  }

  getDetail(idParametroMaestro: number, id: number) : Observable<ParametroModel> {
    return this.http.get<ParametroModel>(`${this.configUrl}/${idParametroMaestro}/items/${id}`);
  }

  updateDetail(model: ParametroModel) {
    return this.http.put<ActionResultModel>(
      `${this.configUrl}/${model.idParametroMaestro}/items/${model.idParametroDetalle}`,
      model
    );
  }
}
